import { render, staticRenderFns } from "./alliance-member-item.vue?vue&type=template&id=3a1966c6&"
import script from "./alliance-member-item.vue?vue&type=script&lang=js&"
export * from "./alliance-member-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports